export const TRIAL_PAGES_V2A = 'v2a';
